import { Stack } from "@mui/joy";
import InvoicesSidebar, { INVOICES_SIDEBAR_WIDTH } from "./components/sidebar/InvoicesSidebar";
import NoInvoiceSvg from "./components/viewer/NoInvoiceSvg";
import { useState, useEffect } from "react";
import InvoiceViewer from "./components/viewer/InvoiceViewer";
import { useSearchParams } from "react-router-dom";
import { IFInvoiceWithDetailsObj } from "@/types/interfaces/crm";

const InterfaceValidator = () => {
  const [selectedInvoice, setSelectedInvoice] = useState<string>("");
  const [selectedInvoiceIndex, setSelectedInvoiceIndex] = useState<number>(-1);
  const [invoices, setInvoices] = useState<IFInvoiceWithDetailsObj[]>([]);
  const [searchParams] = useSearchParams();
  const invoiceId = searchParams.get("invoiceId");

  useEffect(() => {
    if (invoiceId) {
      setSelectedInvoice(invoiceId);
    }
  }, [invoiceId]);

  return (
    <Stack
      direction={"row"}
      sx={{
        flex: 1,
        paddingLeft: `${INVOICES_SIDEBAR_WIDTH}px`,
        width: "100%",
      }}
    >
      <InvoicesSidebar
        invoices={invoices}
        setInvoices={setInvoices}
        selectedInvoiceIndex={selectedInvoiceIndex}
        setSelectedInvoiceIndex={setSelectedInvoiceIndex}
        selectedInvoice={selectedInvoice}
      />
      {selectedInvoice ? (
        <InvoiceViewer
          invoices={invoices}
          selectedInvoiceIndex={selectedInvoiceIndex}
          setSelectedInvoiceIndex={setSelectedInvoiceIndex}
        />
      ) : (
        <Stack
          sx={{
            flex: 1,
            height: "100%",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <NoInvoiceSvg />
        </Stack>
      )}
    </Stack>
  );
};

export default InterfaceValidator;
